import {Link} from 'react-router-dom';
import {Button} from 'antd';

import {toCollectionId} from '../../../config/routes';

import banner from './banner14feb.jpg';

import cls from '../Index.module.scss';

export const Banner14Feb = () => (
    <div className={cls.banner}>
        <div className={cls.left}>
            <div className={cls.headline}>
                <span className={cls.one}>Подарки близким</span> <span
                className={cls.two}>сделаны с&nbsp;любовью</span>
            </div>
            <Link to={toCollectionId('dpujyxr6wi5o6n2o0trqyzh0')}><Button type={'primary'} className={cls.button}>Перейти в каталог</Button></Link>

        </div>
        <div className={cls.right} style={{backgroundImage: `url(${banner})`}}/>
    </div>
)